export default "__VITE_ASSET__BQv8FC4J__"